import {Injectable} from '@angular/core';
import {
  FilterDto,
  KnowledgeArticleStartDto, KnowledgeArticleSummaryDto,
  KnowledgeExamAnswerDto,
  KnowledgePathListDto,
  KnowledgePathStartDto,
} from '@server-models';
import {Observable, throwError} from 'rxjs';
import {ILocalPageOutputDto} from '@shared/interfaces/orga-response.interface';
import {catchError, map} from 'rxjs/operators';
import {IPaginationParams} from '@shared/interfaces/pagination-params.interface';
import {CoreHttpClientApiBaseService} from '@core/services/http-client-api-base/core-http-client-api-base.service';

@Injectable({
  providedIn: 'root'
})
export class SharedKnowledgeService extends CoreHttpClientApiBaseService {
  /**
   * @name getPathItems
   * @description
   * get the knowledge path list
   * @memberof SharedKnowledgeService
   * @param params
   */
  getPathItems(params: IPaginationParams, filter: FilterDto[]): Observable<ILocalPageOutputDto<KnowledgePathListDto[]>> {
    const options = {
      params: {
        PageSize: params.pageSize.toString(),
        PageNumber: params.pageNumber.toString(),
        Cols: params.cols,
        Sort: params.sort!.toString()
      }
    }
    return super.post<ILocalPageOutputDto<KnowledgePathListDto[]>>(`/orga/v2/knowledgePath/filter`,
      undefined, filter, options).pipe(
      map((res: ILocalPageOutputDto<KnowledgePathListDto[]>) => {
        return res;
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  /**
   * @name getKnowledgePathById
   * @description
   * get the knowledge path items by id
   * @memberof SharedKnowledgeService
   * @param id
   * @return {Observable<KnowledgePathStartDto>}
   */
  getKnowledgePathById(id: string): Observable<KnowledgePathStartDto> {
    return super.get<KnowledgePathStartDto>(`/orga/v2/knowledgePath/${ id }/start`,
      undefined).pipe(
      map((res: KnowledgePathStartDto) => {
        return res;
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  /**
   * @name getArticle
   * @description
   * request to v3 orga the knowledge article by id
   * @memberof SharedKnowledgeService
   * @param id
   * @returns {Observable<KnowledgePathStartDto>}
   */
  getArticle(id: number): Observable<KnowledgeArticleStartDto> {
    return super.get<KnowledgeArticleStartDto>(`/orga/v3/knowledgeArticle/${ id }/start`, undefined);
  }

  /**
   * @name getBySearch
   * @description
   * make a request to search knowledges by search text
   * @memberof
   * @param searchText
   * @return {Observable<ILocalPageOutputDto<KnowledgePathListDto[]>>}
   */
  getBySearch(searchText: string): Observable<ILocalPageOutputDto<KnowledgePathListDto[]>> {
    const options = {
      params: {
        q: searchText
      }
    }
    return super.get<ILocalPageOutputDto<KnowledgePathListDto[]>>(`/orga/v3/knowledgeArticle/search`, undefined, options);
  }

  getSummaryBySearch(searchText: string): Observable<KnowledgeArticleSummaryDto> {
    const options = {
      params: {
        q: searchText
      }
    }
    return super.get<KnowledgeArticleSummaryDto>(`/orga/v3/knowledgeArticle/summarize`, undefined, options);
  }

  getExamAnswerById(params: { examId: string, pathId: string }): Observable<KnowledgeExamAnswerDto> {
    return super.get<KnowledgeExamAnswerDto>(`/orga/v2/knowledgeExamAnswer/get`, undefined, { params });
  }

  submitExamAnswer(exam: KnowledgeExamAnswerDto): Observable<KnowledgeExamAnswerDto> {
    return super.post<KnowledgeExamAnswerDto>(`/orga/v2/knowledgeExamAnswer/submit`, undefined, exam);
  }
}
